import { Link } from 'react-router-dom';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import Button from '@mui/material/Button';

const CalculationLinkBox = ({ el, handleFavorite, favorites, user }) => {
  const isFavorite = favorites.includes(el.id);

  return (
    <article className={el.className}>
      {el.new && <div className="badge-new pulse">NEW</div>}
      <div className="title">{el.title}</div>
      {el.description && <p className="description">{el.description}</p>}

      <div className="homepageButtonContainer" aria-label={`${el.title} actions`}>
        <Link to={el.link} aria-label={`Open ${el.title} calculator`}>
          <Button variant="contained" size="small" style={{ fontSize: '12px' }}>
            Calculate
          </Button>
        </Link>
        <Link to={el.theoryLink} aria-label={`Open ${el.title} theory`}>
          <Button variant="outlined" size="small" style={{ fontSize: '12px' }}>
            Info
          </Button>
        </Link>
        {user && (
          <div className="favoriteIcon" role="button" aria-label={`Toggle favorite for ${el.title}`} tabIndex={0}>
            {isFavorite ? (
              <FavoriteIcon color="info" fontSize="medium" onClick={(e) => handleFavorite(e, el.id)} />
            ) : (
              <FavoriteBorderIcon color="info" fontSize="medium" onClick={(e) => handleFavorite(e, el.id)} />
            )}
          </div>
        )}
      </div>
    </article>
  );
};

export default CalculationLinkBox;
